import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_text.png'


const _withScopeId = n => (_pushScopeId("data-v-5437ec80"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-lg",
  src: _imports_0
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "recaptcha-container" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "grecaptcha-div" })
], -1))
const _hoisted_3 = { style: {"padding-left":"16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, { style: {"max-width":"768px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_content, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select, {
                                interface: "alert",
                                fill: "outline",
                                modelValue: $setup.user.dialCode,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.user.dialCode) = $event)),
                                "selected-text": $setup.user.dialCode
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countryCodeOptions, (option) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: option.dial_code,
                                      value: option.dial_code
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(option.emoji) + " " + _toDisplayString(option.name) + " (" + _toDisplayString(option.dial_code) + ") ", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "selected-text"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "8" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                label: $setup.t('loginPhone'),
                                "label-placement": "floating",
                                fill: "outline",
                                inputmode: "numeric",
                                modelValue: $setup.user.phone,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.user.phone) = $event))
                              }, null, 8, ["label", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "10" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        shape: "round",
                        expand: "block",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.doLogin()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('next')) + " ", 1),
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: $setup.arrowForward
                          }, null, 8, ["icon"]),
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ion_select, {
          interface: "popover",
          modelValue: $setup.locale,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.locale) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_select_option, { value: "zh" }, {
              default: _withCtx(() => [
                _createTextVNode("中文")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_select_option, { value: "en" }, {
              default: _withCtx(() => [
                _createTextVNode("English")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }))
}